import { useState } from "react";
import { StabilityAiTransport } from "../../transports/stabilityAi";
import { PageTitle } from "src/_metronic/layout/core";
import { useIntl } from "react-intl";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";
import { Row, Col, Form } from "react-bootstrap";
import { ImageGridContainer } from "src/app/containers";
import Pacman from "src/app/components/layout/Pacman";
import { LangType } from "src/app/types/LangType";

const Imageia = () => {
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState<string | undefined>();
    const [currentLang, setCurrentLang] = useState<LangType>(LangType.FR);

    const { formatMessage } = useIntl();

    const langs = Object.keys(LangType);

    const getImage = () => {
        if (title) {
            setLoading(true);
            StabilityAiTransport.getImageByJarvisPrompt(title, currentLang)
                .then((res) => setImage(res))
                .finally(() => setLoading(false));
        }
    };

    return (
        <>
            <PageTitle>{formatMessage({ id: "imagia.title" })}</PageTitle>
            <Row>
                <Col sm={4} style={{ margin: "0 0 8px 0" }}>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            getImage();
                        }}
                    >
                        <label className="form-label">
                            {formatMessage({ id: "common.field.title" })}
                        </label>
                        <br />
                        <input
                            name="prompt"
                            type="text"
                            className="is-valid form-control"
                            value={title}
                            onChange={(e) => setTitle(e.currentTarget.value)}
                        />
                        <Row>
                            {langs.map((lang, index) => (
                                <Col key={index} className="mb-2 col-sm-4">
                                    <label
                                        htmlFor={`lang${index}`}
                                        className="hover-outline"
                                        key={index}
                                    >
                                        <Form.Check
                                            type="radio"
                                            checked={lang === currentLang}
                                            onChange={(el) => {
                                                const value = el.currentTarget.value;
                                                setCurrentLang(
                                                    LangType[value as keyof typeof LangType]
                                                );
                                            }}
                                            label={
                                                <SVG
                                                    width={16}
                                                    src={toAbsoluteUrl(
                                                        `/media/flags/${lang.toLowerCase()}.svg`
                                                    )}
                                                />
                                            }
                                            value={lang}
                                            name="lang"
                                        />
                                    </label>
                                </Col>
                            ))}
                        </Row>
                        <button
                            disabled={loading}
                            className="btn btn-sm btn-primary btn btn-primary"
                            type="submit"
                        >
                            Generate
                        </button>
                    </form>
                </Col>
                <Col sm={8}>
                    <div
                        style={{
                            width: "100%",
                            height: 464,
                            border: "4px solid",
                            borderColor: "var(--kt-primary)",
                        }}
                    >
                        {loading ? (
                            <div
                                style={{
                                    display: "flex",
                                    width: "100%",
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Pacman />
                            </div>
                        ) : (
                            <>
                                {image && (
                                    <img
                                        width="100%"
                                        height="100%"
                                        src={`data:image/webp;base64, ${image}`}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </Col>
            </Row>
            <ImageGridContainer />
        </>
    );
};

export default Imageia;
